import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
const useCustomCursorEnabled = () => {
  const $ = _c(2);
  const [isEnabled, setIsEnabled] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const checkPerformance = _temp;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (!isMobile && checkPerformance()) {
        setIsEnabled(true);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isEnabled;
};
export default useCustomCursorEnabled;
function _temp() {
  const start = performance.now();
  let count = 0;
  while (performance.now() - start < 5) {
    count++;
  }
  return count > 1000;
}